export const RASCUNHO = { id: 2, value: 'Rascunho' };
export const PENDENTE = { id: 3, value: 'Pendente' };
export const DEVOLVIDO = { id: 4, value: 'Devolvido' };
export const CANCELADO = { id: 5, value: 'Cancelado' };
export const APROVADO = { id: 6, value: 'Aprovado' };
export const PROGRAMADO = { id: 7, value: 'Programado' };
export const ENVIADO = { id: 8, value: 'Enviado' };
export const CONCLUIDO = { id: 9, value: 'Concluido' };
export const CONCLUIDORESSALVAS = { id: 10, value: 'Concluido com ressalvas' };
export const PREPARACAO = { id: 11, value: 'Preparação' };
export const PRONTAENTREGA = { id: 12, value: 'Pronto para Entrega' };
export const ENTREGUE = { id: 13, value: 'Entregue' };
export const CRIACAO = { id: 14, value: 'Criação' };
export const REDACAO = { id: 30, value: 'Redação' };
export const PRODUCAO = { id: 15, value: 'Produção' };
export const INDEFINIDO = { id: 15, value: 'Indefinido' };
export const AGUARDANDODEVOLUCAO = {id: 26, value: 'Aguardando Devolução'}
export const TRANSPORTE = {id: 27, value: 'Transporte'}
// export const APROVACAODEREDACAO = {id: 33, value: 'Aprovação de redação'}

export const  namesStatus = id => {
  if (id === RASCUNHO.id) {
    return RASCUNHO.value
  }
  if (id === PENDENTE.id) {
    return PENDENTE.value
  }
  if (id === DEVOLVIDO.id) {
    return DEVOLVIDO.value
  }
  if (id === CANCELADO.id) {
    return CANCELADO.value
  }
  if (id === APROVADO.id) {
    return APROVADO.value
  }
  if (id === PROGRAMADO.id) {
    return PROGRAMADO.value
  }
  if (id === ENVIADO.id) {
    return ENVIADO.value
  }
  if (id === CONCLUIDO.id) {
    return CONCLUIDO.value
  }
  if (id === CONCLUIDORESSALVAS.id) {
    return CONCLUIDORESSALVAS.value
  }

  if (id === PREPARACAO.id) {
    return PREPARACAO.value
  }
  if (id === PRONTAENTREGA.id) {
    return PRONTAENTREGA.value
  }
  if (id === ENTREGUE.id) {
    return ENTREGUE.value
  }
  if (id === CRIACAO.id) {
    return CRIACAO.value
  }
  if (id === REDACAO.id) {
    return REDACAO.value
  }
  if (id === PRODUCAO.id) {
    return PRODUCAO.value
  }
  if (id === INDEFINIDO.id) {
    return INDEFINIDO.value
  }
  if (id === TRANSPORTE.id) {
    return TRANSPORTE.value
  }

  if (id === AGUARDANDODEVOLUCAO.id) {
    return AGUARDANDODEVOLUCAO.value
  }

  // if (id === APROVACAODEREDACAO.id) {
  //   return APROVACAODEREDACAO.value
  // }
  if (id === AGUARDANDODEVOLUCAO.id) {
    return AGUARDANDODEVOLUCAO.value
  }
  return "";

}



// WEBPACK FOOTER //
// ./src/config/StatusRequest.js